export const LESSON_STATUS_OPTIONS = [
  { label: 'Не отчитались', value: '0' },
  { label: 'Проведено', value: '5' },
  { label: 'Перенесено', value: '9' },
  { label: 'Отмена учеником', value: '10' },
  { label: 'Отмена педагогом', value: '11' },
  { label: 'Платная отмена', value: '12' },
]

export function getStatusDescription(value: string) {
  switch (value) {
    case '5':
      return 'Проведено'
    case '9':
      return 'Перенесено'
    case '10':
      return 'Отмена учеником'
    case '11':
      return 'Отмена педагогом'
    case '12':
      return 'Платная отмена'
    default:
      return 'Не отчитались'
  }
}

export function getStatusColor(value: string) {
  switch (value) {
    case '5':
      return 'var(--color-status-success-border)'
    case '9':
      return 'var(--color-status-warning)'
    case '10':
      return 'var(--color-status-danger-border)'
    case '11':
      return 'var(--color-status-danger-border)'
    case '12':
      return 'var(--color-status-danger-bg)'
    default:
      return 'var(--color-status-warning-border)'
  }
}
